import { render } from "./Verify.vue?vue&type=template&id=8efcde4a"
import script from "./Verify.vue?vue&type=script&lang=js"
export * from "./Verify.vue?vue&type=script&lang=js"

import "./Verify.vue?vue&type=style&index=0&id=8efcde4a&lang=css"

import exportComponent from "/Users/h5/Desktop/project/外包/huiduoduo/chn-link/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__